const ALLOWED_BUSINESS_CATEGORY_ID = [
  51, // Retail - Apparel & Accessories
  67, // Retail - Baby
  68, // Retail - Electronics
  69, // Retail - Furniture, Home, & Garden
  70, // Retail - Health & Beauty
  63, // Retail - Other
  71, // Retail - F & B
];

const ALLOWED_EMAIL = [];

export { ALLOWED_BUSINESS_CATEGORY_ID, ALLOWED_EMAIL };
